<template>
    <div class="container" >
        <div class="row">
            <div class="col">
                <h1>Хичээлүүд</h1>
            </div>
            <div class="col-auto">
                <i class="fas fa-grip-horizontal text-danger" style="font-size:20px;" v-if="showHidden" @click="showHidden=!showHidden"></i>
                <i class="fas fa-grip-lines text-danger" style="font-size:20px;" v-else @click="showHidden=!showHidden"></i>
            </div>
         
        </div>
        <ul>
            <li v-for="(school, index) in schools" v-bind:key="'school'+index">
                <h4>{{school.name}}</h4>
                <ul>
                    <li v-for="(department, index1) in school.departments" v-bind:key="department.id">
                        <h5>{{department.name}}</h5>
                         <ul>
                            <li v-for="(program, index2) in department.programs" v-bind:key="program.id" style="list-style-type:none;margin-bottom:12px;cursor:pointer">
                                <div  class="bg-success text-white row" v-bind:class="{ '': program.collapsed==false }" @click="program.collapsed=!program.collapsed">
                                    <div class="col">
                                        <h5>
                                            {{index2+1}}. {{program.name}}
                                            <small v-if="program.collapsed">/хичээлийн тоо: {{program.lessons.length}}/</small>
                                        </h5> 
                                        
                                     
                                    </div>
                                    <div  class="col-auto" >
                                        <i v-if="program.collapsed==true" class="fas fa-arrow-circle-down" style="font-size:30px;"></i>
                                        <i v-else class="fas fa-arrow-circle-up" style="font-size:30px;"></i>
                                    </div>

                                </div>
                                <div v-if="program.collapsed==false">
                                    <ol v-if="program.lessons!=null && program.lessons.length>0">
                                        <li v-for="(lesson, index) in program.lessons" v-bind:key="lesson.id" @click="goDetail(lesson)" style="cursor:pointer;margin-bottom:10px" v-if="(showHidden==true) || (showHidden==false && lesson.hide!=true)">
                                            <h6 class="text-success">{{lesson.name}}</h6>
                                            <span class="text-danger ml-2">{{lesson.teacherFirstName}}</span>
   
                                            <span class="text-primary ml-2" v-if="lesson.numberOfTopics">    
                                                Сэдвийн тоо: {{lesson.numberOfTopics}}
                                                
                                            </span>
                                            <span  class=" ml-2" v-if="lesson.numberOfVideos">Video тоо: {{lesson.numberOfVideos}}</span>

                                            <span v-if="lesson.hide!=true" v-on:click.stop="hideLesson(lesson)" class="ml-5 badge badge-pill badge-danger"><i class="far fa-times-circle mr-2"></i>нуух</span>
                                            <span v-else @click.stop="showLesson(lesson)" class="ml-5 badge badge-pill badge-info">нуусан</span>
                                        </li>
                                    </ol>
                                    <div v-else class="mt-3 alert alert-info">Одоогоор энэ хөтөлбөр дээр хичээл ороогүй байна.</div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

        <div v-if="lessons!=null && lessons.length>0">
            <h3>Бүх хичээлүүд</h3>
            <ol>
                <li v-for="(lesson, index) in lessons" v-bind:key="'lesson_'+lesson.id" @click="goDetail(lesson)"  style="cursor:pointer; margin-bottom: 12px;">
                    <h4>{{lesson.name}}</h4>
                    <span class="text-danger ml-2">{{lesson.teacherFirstName}}</span>

                        <span class="text-primary ml-2" v-if="lesson.numberOfTopics">    
                            Сэдвийн тоо: {{lesson.numberOfTopics}}
                            
                        </span>
                        <span  class=" ml-2" v-if="lesson.numberOfVideos">Video тоо: {{lesson.numberOfVideos}}</span>
                    <hr/>

                </li>
            </ol>
        </div>

    </div>
</template>

<script>
const fb = require('../firebaseConfig.js');
import { mapState } from 'vuex'
export default {
    name: "AllLessons",
    data() {
        return {
            schools:[],
            lessons:[],
            types:[],
            showHidden:false
        };
    },
    computed: {
        ...mapState(['currentUser', 'userProfile'])
    },
    methods: {
        _getTypes(){
            fb.db.collection("LessonTypes").get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(schoolData=>{
                        let object=schoolData.data()
                        object.id=schoolData.id
                        this.types.push(object)
                    })
                }
            })
        },
       _getSchools(){
            if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
                fb.db.collection("schools").get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(schoolData=>{
                            let object=schoolData.data();
                            object.id=schoolData.id;
                            object.departments=[];
                            this._getDepartments(schoolData, object);
                            this.schools.push(object);
                        })
                    }
                });
            }
            else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null){
                this.userProfile['customer'].get().then(cusDoc=>{
                    if(cusDoc.exists && cusDoc.data().schools!=null){
                        for(const scRef of cusDoc.data().schools){
                            scRef.get().then(schoolData=>{
                                let object=schoolData.data();
                                object.id=schoolData.id;
                                object.departments=[];
                                this._getDepartments(schoolData, object);
                                this.schools.push(object);
                            });
                        }
                    }
                });
            }
        },
        _getDepartments(schoolData, school){
            if(schoolData!=null){
                schoolData.ref.collection("departments").get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(depData=>{
                            let object=depData.data()
                            object.id=depData.id
                            object.programs=[]
                            this._getPrograms(depData, object)
                            school.departments.push(object)
                        })
                    }
                })
            }
        },
        _getPrograms(depData, department){
            if(depData!=null){
                depData.ref.collection("programs").get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(proData=>{
                            let object=proData.data()
                            object.id=proData.id
                            object.lessons=[];
                            object.collapsed=true;
                            this._getLessons(proData, object)
                            department.programs.push(object)
                        })
                    }
                })
            }
        },
        _getLessons(proData, program){
            if(proData!=null){
                fb.db.collection("lessons").where("program", "==", proData.ref).get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(lessonData=>{
                            let object=lessonData.data();
                            object.id=lessonData.id;
                            
                            // this.types.forEach((type, index)=>{
                            //     object[type.id]=[]
                            //     this._getTopics(lessonData.id, type.id, object[type.id])
                            // })
                            // if(object.hide!=true)
                                program.lessons.push(object)

                        })
                    }
                })
            }
        },
        _getTopics(lessonId, typeid, item){
            fb.db.collection("lessons").doc(lessonId).collection(typeid).get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(topicData=>{
                        let object=topicData.data()
                        object.id=topicData.id
                        item.push(object)
                        
                    })
                }
            })
        },
        _getLessonsDefault(){
            // if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
            //     fb.db.collection("lessons").where("program", "==", null).get().then(querySnapshot=>{
            //         if(querySnapshot!=null && !querySnapshot.empty){
            //             querySnapshot.forEach(lessonData=>{
            //                 let object=lessonData.data()
            //                 object.id=lessonData.id
            //                 this.types.forEach((type, index)=>{
            //                     object[type.id]=[]
            //                     this._getTopics(lessonData.id, type.id, object[type.id])
            //                 })
            //                 this.lessons.push(object)
            //             })
            //         }
            //     });
            // }

        },
         goDetail(lesson){
          this.$router.push({ name: 'LessonDetailAdmin', params: { lessonId: lesson.id} })
        },
        hideLesson(lesson){
            var r = confirm("Та "+lesson.name+' хичээлийг нуухдаа итгэлтэй байна уу.Ингэснээр энэ хичээл танд харагдахгүй болно.');
            if (r == true) {
                fb.db.collection("lessons").doc(lesson.id).update({"hide":true});
                lesson.hide=true;
            }

        },
        showLesson(lesson){
  
            fb.db.collection("lessons").doc(lesson.id).update({"hide":false});
            lesson.hide=false;

        }

    },
    created() {
        // this._getTypes();
        this._getSchools();  
        this._getLessonsDefault();
    },
};
</script>

